import React from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { cn } from "../lib/utils";

const Contacto = ({ isOpen, onClose, id, titulo }) => {
  const baseUrl = window.location.origin;
  const shareUrl = `${baseUrl}/ver-licitacion/${id}/procu`;
  const shareText = "Postula a esta licitación en nuestra plataforma!";
  const fullText = `${shareText} ${shareUrl}`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(fullText);
    toast.success("Texto copiado al portapapeles");
  };

  const redes = [
    {
      key: "linkedin",
      label: "Linkedin",
      icon: "linkedin.png",
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
      className: "bg-[#0a66c2]/10 text-[#0a66c2] hover:bg-[#0a66c2]/20",
    },
    {
      key: "facebook",
      label: "Facebook",
      icon: "facebook.png",
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      className: "bg-[#1877f2]/10 text-[#1877f2] hover:bg-[#1877f2]/20",
    },
    {
      key: "whatsapp",
      label: "WhatsApp",
      icon: "whatsapp.png",
      href: `https://api.whatsapp.com/send?text=${encodeURIComponent(fullText)}`,
      className: "bg-[#25d366]/10 text-[#25d366] hover:bg-[#25d366]/20",
    },
  ];

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Compartir en redes sociales</DialogTitle>
        </DialogHeader>

        <small className="text-muted-foreground">Copia este mensaje:</small>
        <div className="mt-1 flex items-center gap-2 rounded-md border border-border p-3">
          <p className="flex-1 text-sm">{fullText}</p>
          <button
            onClick={copyToClipboard}
            className="shrink-0 rounded-md p-2 hover:bg-muted"
            title="Copiar"
          >
            <img
              src={`${process.env.PUBLIC_URL}/fotos/copiar.png`}
              alt="Copiar"
              className="h-5 w-5"
            />
          </button>
        </div>

        <p className="mt-4 text-sm text-muted-foreground">Y compártelo en todas estas redes:</p>
        <div className="mt-2 flex flex-wrap gap-2">
          {redes.map((red) => (
            <a
              key={red.key}
              href={red.href}
              target="_blank"
              rel="noopener noreferrer"
              className={cn(
                "flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                red.className
              )}
            >
              <img
                src={`${process.env.PUBLIC_URL}/fotos/${red.icon}`}
                alt={red.label}
                className="h-5 w-5 object-contain"
              />
              {red.label}
            </a>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Contacto;
